var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('v-card',[_c('v-card-text',{staticClass:"text-center"},[_vm._v(" ⓒ "+_vm._s(new Date().getFullYear())+" 기후위기부천비상행동 ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }